module.exports = __webpack_public_path__ + "static/media/virgen-coromoto-ojo-detalles.d989cdbe.jpg";